var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sectionGroups),function(item,idx){return _c('target-section',{key:idx,attrs:{"sect-grp-id":item.sectGrpId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }